// extracted by mini-css-extract-plugin
export default {"wrapper":"settings-page_wrapper__OF6XL"};